//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum FileTypesEnum {
    Image = 1,
    Video = 2,
    InspectionFile = 3,
    Document = 4,
    PanoramoFilm = 5,
}
